export default class DesignerPeerCategory {
    static Unknown = 'Unknown';
    static Containers = 'Containers';
    static Elements = 'Elements';
    static Inputs = 'Inputs';
    static Actions = 'Actions';
}
